// extracted by mini-css-extract-plugin
export var cardLayout = "_6g-1";
export var paginationContainer = "_6g-0";